<template>
  <div class="personal_center service_provider">
    <div class="parkSwitch">
      当前园区：
      <template v-if="authPark">
        {{authPark.incubator_name}}-{{authPark.extend3}}
        <router-link to="/personal_center/service_provider/switchCampus">切换园区</router-link>
      </template>
      <template v-else>
        请先入驻园区成为服务商
      </template>
    </div>
    <div class="m">
      <div class="left_box">
        <el-menu :default-openeds="['1','2','3','4']" :default-active="curActive">
          <el-submenu index="1">
            <template slot="title">
              <i class="iconfont">&#xe6cb;</i>
              <span>交易管理</span>
            </template>
            <el-menu-item index="1-1">
              <router-link to="/personal_center/service_provider/service_provider_order">我的订单</router-link>
            </el-menu-item>
            <!--            <el-menu-item index="/personal_center/service_provider/my_evaluation">-->
            <!--              <router-link to="/personal_center/service_provider/my_evaluation">我的评价</router-link>-->
            <!--            </el-menu-item>-->
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="iconfont">&#xe604;</i>
              <span>店铺信息</span>
            </template>
            <el-menu-item index="2-1">
              <router-link to="/personal_center/service_provider/store_info">店铺信息</router-link>
            </el-menu-item>
            <el-menu-item index="2-2">
              <router-link to="/personal_center/service_provider/my_service">我的服务</router-link>
            </el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">
              <i class="iconfont">&#xe680;</i>
              <span>入驻认证</span>
            </template>
            <el-menu-item index="3-1">
              <router-link to="/personal_center/service_provider/settled_in">入驻成为服务商</router-link>
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="right_box">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions,mapState } from 'vuex'
  export default {
    data() {
      return {
        curActive: '1-1',
        auth: null
      }
    },
    watch: {
      '$route': 'setCurActive'
    },
    computed: {
      ...mapState('service_provider', {
        authPark: state => state.authPark
      }),
      info() {
        return this.$store.state.info
      }
    },
    created() {
      this.setCurActive();
      //查询默认园区
      if(this.info){
        this.$store.dispatch('service_provider/setAuthPark');
      }else{
        this.needInfo();
      }
    },
    methods: {
      /* 监测Props */
      needInfo(name) {
        let watchAch = this.$watch("info", (val, oldVal) => {
          if (val) {
            this.$store.dispatch('service_provider/setAuthPark');
            watchAch(); //取消监听
          }
        });
      },
      //设置选中菜单
      setCurActive() {
        let path = this.$route.path;
        let active = '';
        if (path.indexOf('service_provider_order') !== -1) {
          active = '1-1';
        } else if (path.indexOf('store_info') !== -1) {
          active = '2-1'
        } else if (path.indexOf('my_service') !== -1) {
          active = '2-2'
        } else if (path.indexOf('settled_in') !== -1) {
          active = '3-1'
        }
        this.curActive = active;
      }
    }
  };
</script>

<style lang="scss">
  @import "../index.scss";

  .service_provider {
    .parkSwitch {
      width: 1200px;
      margin: 0 auto !important;
      padding-top: 20px;
      color: #333;
      font-size: 14px;

      a {
        margin-left: 10px;
        color: #4c84ff;
      }
    }
  }
</style>
